import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
//Farshidx
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";
import ReactPlayer from 'react-player';

import CreditCardForm from "./CreditCardForm.js";

import ImageGallery from "react-image-gallery";
// import stylesheet if you're not already using CSS @import
import "react-image-gallery/styles/css/image-gallery.css";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import ReCAPTCHA from "react-google-recaptcha";
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import axios from "axios";

//import React from 'react';
//import ImageGallery from 'react-image-gallery';

const VideoSlide = () => (
    <div className="video-wrapper">
      <video controls width="50%" poster="/static/images/IMG_7191.png">
        <source src="/static/images/file_example_MP4_1280_10MG.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
);

const VideoSlide1 = () => (
    <div className="video-wrapper">
      <video controls width="60%" height="30%" poster="/static/images/DSC08313.JPG">
        <source src="/static/images/OrchimaWatering.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
);

const VideoSlide2 = () => (
    <div className="video-wrapper">
      <video controls width="60%" height="30%" poster="/static/images/OrchimaWaterReleasepng.png">
        <source src="/static/images/OrchimaWaterRelease.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
);
/*
const items = [
  {
    original: '/image1.jpg',
    thumbnail: '/thumb1.jpg',
  },
  {
    renderItem: () => <VideoSlide />,
    thumbnail: '/video-thumbnail.jpg',
  },
  {
    original: '/image2.jpg',
    thumbnail: '/thumb2.jpg',
  }
];

export default function App() {
  return <ImageGallery items={items} />;
}

 */


/*const images = [
  {
    original: "https://picsum.photos/id/1018/1000/600/",
    thumbnail: "https://picsum.photos/id/1018/250/150/",
  },
  {
    original: "https://picsum.photos/id/1015/1000/600/",
    thumbnail: "https://picsum.photos/id/1015/250/150/",
  },
  {
    original: "https://picsum.photos/id/1019/1000/600/",
    thumbnail: "https://picsum.photos/id/1019/250/150/",
  },
];*/




const images = [
  /*{
    original: "/static/images/DSC08295.JPG",
    thumbnail: "/static/images/DSC08295.JPG",
    originalHeight:"600",
    originalWidth:"600",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Orchima Pot",
    thumbnailTitle:"Orchima Pot",
    thumbnailLabel:"Orchima Pot",
    description:"Description 1"
  },*/
  /*{
    original: "/static/images/DSC08300.JPG",
    thumbnail: "/static/images/DSC08300.JPG",
    originalHeight:"600",
    originalWidth:"600",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Some title",
    thumbnailTitle:"Some nails",
    thumbnailLabel:"Label 2",
    description:"Description 2"
  },*/
  /*{
    original: "/static/images/DSC08313.JPG",
    thumbnail: "/static/images/DSC08313.JPG",
    originalHeight:"600",
    originalWidth:"600",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Some title",
    thumbnailTitle:"Some nails",
    thumbnailLabel:"Label 3",
    description:"Description 3"

  },
  {
    original: "/static/images/DSC08292.JPG",
    thumbnail: "/static/images/DSC08292.JPG",
    originalHeight:"600",
    originalWidth:"600",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Some title",
    thumbnailTitle:"Some nails",
    thumbnailLabel:"Label 4A",
    description:"Description 4"
  },*/
  /*{
    original: "/static/images/DSC08276.JPG",
    thumbnail: "/static/images/DSC08276.JPG",
    originalHeight:"600",
    originalWidth:"600",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Orchima Pot bottom",
    thumbnailTitle:"Orchima Pot bottom",
    thumbnailLabel:"Orchima Pot bottom",
    description:"Orchima Pot bottom"
  },*/
  {
    //original: "/static/images/file_example_MP4_1280_10MG.mp4",
    renderItem: () => <VideoSlide1 />,
    thumbnail: "/static/images/DSC08313.JPG",
    originalHeight:"200",
    originalWidth:"200",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Watering Orchima Pot",
    thumbnailTitle:"Watering Orchima Pot",
    thumbnailLabel:"Watering Orchima Pot",
    description:"Watering Orchima Pot"
  },
  {
    //original: "/static/images/file_example_MP4_1280_10MG.mp4",
    renderItem: () => <VideoSlide2 />,
    thumbnail: "/static/images/OrchimaWaterReleasepng.png",
    originalHeight:"200",
    originalWidth:"200",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Releasing water",
    thumbnailTitle:"Releasing water",
    thumbnailLabel:"Releasing water",
    description:"Releasing Water"
  },
];



//import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
//import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//End Farshid



const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    //marginTop: theme.spacing.unit * 3,
    height: '20px',
    color:"#ffffff",
    //backgroundColor:"#760eb3",
  },

  multilineColor:{
    color:'black',
    backgroundColor:'#f5f7e8'
  }
});


class OrchimaMainPage extends Component {

  state = {
    age: '',
    name: 'hai',
    firstname: '',
    lastname:'',
    email:'',
    comment:'',
    userComment:{},
    selectedUser:{},
    showOrderForm:false,
    showOrderDialog: false,
    captchaValue:"",
    potPrice:3.50,

  };

  constructor(props) {
    super(props);

    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange= this.handleEmailChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.saveVisitorComment = this.saveVisitorComment.bind(this);

    this.handleAddress2Change = this.handleAddress2Change.bind(this);
    this.handleShowOrderFormChange = this.handleShowOrderFormChange.bind(this);
    this.handleClickShowOrderDialog = this.handleClickShowOrderDialog.bind(this);
    this.handleClickShowOrderDialogClose = this.handleClickShowOrderDialogClose.bind(this);
    this.handleCaptchaChange= this.handleCaptchaChange.bind(this);
    this.recaptchaRef = React.createRef();


  }


  componentDidMount() {
    const { isAuthenticated ,updateUserProfileAction} = this.props;
    //isAuthenticated();
    //updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
    //updateUserProfileAction(null, this.props.loginData.accessToken);
    //this.getPotPriceFromServer(DEFAULT_VESPAAN_SERVER.url);
    //updateAuth();
    // console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;

  }


  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleShowOrderFormChange = event => {
    //this.setState({ showOrderForm:!this.state.showOrderForm });
    //this.getPotPriceFromServer(DEFAULT_VESPAAN_SERVER.url);
    this.setState({ showOrderDialog:true });

  };

  handleFirstNameChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));

    //this.setState({userComment , {{firstname:event.target.value }});
    // this.setState(Object.assign(this.state.firstname, event.target.value));
  }

  handleLastNameChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.lastname, event.target.value));
    this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));

  }

  handleEmailChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.email,event.target.value));
    this.setState(Object.assign(this.state.userComment,{email:event.target.value}));

  }
  handleCommentChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
  }

  handleClickShowOrderDialog(){
    this.setState({ showOrderDialog: true });
  };


  handleClickShowOrderDialogClose(){
    //let { clearCardErrorMsg } = this.props;
    this.setState({ showOrderDialog: false });
    //clearCardErrorMsg();
  };

  saveVisitorComment(){
    const {saveAComment} = this.props;
    var  returnString="";
    var tempLastName =  this.state.userComment.lastname;
    var tempFirstName = this.state.userComment.firstname;
    var tempEmail = this.state.userComment.email;
    var tempComment = this.state.userComment.comment;


    if((tempFirstName == null) || (tempFirstName.length == 0)){
      alert("Please provide your first name!");
    }else {

      if ((tempLastName == null) || (tempLastName.length == 0)) {
        alert("Please provide your last name!");
      }else {

        if ((tempEmail == null) || (tempEmail.length == 0)) {
          alert("Please provide your Email!");
        } else {

          if ((tempEmail.indexOf("@") == -1)) {
            alert("Please provide proper Email address!");
          }else{
            if ((tempComment == null) || (tempComment.length == 0)) {
              alert("Please provide your comment!");
            }else{
              //Here send the data to the back end.
              saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);

            }
          }
        }
      }
    }

    return returnString;
  }

//Background color was backgroundColor:'#f4f3ed',

  handleAddress2Change(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.selectedUser,{address2:event.target.value}));
  }


  handleCaptchaChange = (value) => {
    this.setState({ captchaValue: value });
  };



  render() {
    let shorOrderFormButtonText="";
    let tempImageSource2 = "/static/images/OrchimaLogo2.png";
    const { classes } = this.props;
    const MyLink = props => <RouterLink to="#top2" {...props} />
    if( !this.state.showOrderForm){
      shorOrderFormButtonText = "Place a Purchase Order";
    }else{
      shorOrderFormButtonText = "Hide Order Form";
    }
    return (

        <div id="top1"  style={{  }}>
          <Grid container spacing={24}>

            <Grid   item xs={12} sm={12}  >


              <div    style = { {  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat'  }}>
                {/*}
                <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:26}}>
                  Stop Guessing. Start Growing Healthy Orchids.
                </Typography> */}

                <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>

                  <Grid container spacing={24}>
                    <Grid   item xs={1} sm={1}  >
                    </Grid>
                    <Grid   item xs={10} sm={10}  >


                      <Grid container spacing={24}>
                        <Grid   item xs={12} sm={12} md={12} lg={12}   xl={12}  >

                          <div style={{paddingLeft:10, paddingBottom:0, paddingTop:20, display: 'flex', flexDirection: 'column', justifyContent: 'left' ,marginBottom:0 }}>
                            <Typography variant="h4" component="h4" style = { {textAlign: 'center', alignSelf: 'left', paddingBottom:'50', marginBottom:'0', width:'300', fontSize:30}}>
                              {/*} {MainConstants.APPLICATION_NAME}&trade; makes watering simple with a unique built-in system.*/}
                              {MainConstants.APPLICATION_NAME}&trade; Orchid Care System
                            </Typography>
                            <Typography variant="h4" component="h4" style = { {textAlign: 'center', alignSelf: 'left', paddingBottom:'50', marginBottom:'0', width:'300', fontSize:30}}>
                              {/*} {MainConstants.APPLICATION_NAME}&trade; makes watering simple with a unique built-in system.*/}
                              A cleaner, simpler way to water orchids.
                            </Typography>
                            <Typography variant="h5" component="h5" style = { {textAlign: 'center', alignSelf: 'left', paddingBottom:'70', marginBottom:'0', width:'300', fontSize:24}}>
                              {/*} {MainConstants.APPLICATION_NAME}&trade; makes watering simple with a unique built-in system.*/}
                              Patent Pending
                            </Typography>
                            <br/>
                            <Typography variant="h6" component="h6" style = { { marginLeft:'200' ,textAlign: 'left', color:'#BF360C', alignSelf: 'center', paddingBottom:'50', marginBottom:'0', width:'300', fontSize:30}}>
                              Fill → Soak → Drain
                            </Typography>
                            {/*<Typography variant="h6" component="h6" style = { { marginLeft:'200' ,textAlign: 'left',  alignSelf: 'center', paddingBottom:'50', marginBottom:'0', width:'300', fontSize:30}}>
                          system
                        </Typography>*/}
                          </div>
                          <div style={{paddingLeft:10, paddingBottom:0, paddingTop:20, display: 'flex', flexDirection: 'column', justifyContent: 'left' ,marginBottom:0 }}>

                            <ul style = { { fontSize:20, color:'black', marginLeft:20 ,marginTop:0 , textAlign: 'center',  alignSelf: 'center'}}>
                              <li >
                                <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', flexDirection:'row', display: 'flex', }}>
                                  <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:22}}>
                                    No more overwatering
                                  </Typography>
                                  </div>
                                </div>
                              </li>
                              <li >
                                <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                                  <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:22}}>
                                    No tipping, no mess
                                  </Typography>
                                  </div>
                                </div>
                              </li>
                              <li >
                                <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                                  <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:22}}>
                                    No removing liners from pots
                                  </Typography>
                                  </div>
                                </div>
                              </li>
                              <li >
                                <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                                  <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:22}}>
                                    Ideal for bark-based orchids
                                  </Typography>
                                  </div>
                                </div>
                              </li>

                            </ul>
                          </div>
                        </Grid>
                        <Grid   item xs={12} sm={12}  md={12} lg={12}   xl={12} >

                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'column', display: 'flex', }}>
                            <div  style={{ flex: 1 }}>
                              {/*<Typography variant="h5" component="h2" style = { {  marginTop:15, textAlign: 'center', alignSelf: 'center'  ,  color:'#BF360C', fontSize:28}}>
                            Fill, Soak, Drain
                          </Typography>
                          <Typography variant="h5" component="h2" style = { {  marginTop:15, textAlign: 'center', alignSelf: 'center'  ,  color:'#BF360C', fontSize:28}}>
                            The easiest way to care for orchids
                          </Typography>*/}
                              <Typography variant="h5" component="h2" style = { {  marginTop:15, textAlign: 'center', alignSelf: 'center'  , color:'black', fontSize:18}}>
                                Click picture to a see a larger view
                              </Typography>
                            </div>
                            <div  style={{marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:300, alignSelf: 'center' ,  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaPotPlant3.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>
                          </div>
                        </Grid>
                      </Grid>

                      <br/>
                      <Grid   item xs={12} sm={12}  md={12} lg={12}   xl={12} >
                        <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', fontSize:28}}>
                          Most Orchids Don’t Die From Neglect—They Die From Inconsistent Watering
                        </Typography>
                        <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                          Orchids are often overwatered, underwatered, or watered inconsistently.
                        </Typography>
                        <div style={{paddingBottom:0,textAlign: 'center', alignSelf: 'center',  paddingTop:20, display:'flex', flexDirection: 'column' ,marginBottom:0 }}>
                          <ul style = { { fontSize:18, color:'black', marginLeft:20 , marginTop:0, textAlign: 'center', alignSelf: 'center' ,  }}>
                            <li >
                              <div style = { {  marginTop:10, textAlign: 'center', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                                <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'center'  , color:'black', fontSize:18}}>
                                  Too much water leads to root rot
                                </Typography>
                                </div>
                              </div>
                            </li>
                            <li >
                              <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                                <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                  Too little causes dehydration
                                </Typography>
                                </div>
                              </div>
                            </li>
                            <li >
                              <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                                <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                  Messy watering routines make consistency difficult
                                </Typography>
                                </div>
                              </div>
                            </li>

                          </ul>
                        </div>
                        <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                          Even experienced growers know this—beginners struggle with it the most.
                        </Typography>
                      </Grid>

                      <br/>

                      <Grid   item xs={12} sm={12}  md={12} lg={12}   xl={12} >
                        <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', fontSize:28}}>
                          Why Store-Bought Orchids Often Struggle
                        </Typography>
                        <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                          Most orchids sold in stores come planted in tightly packed moss designed for transport — not for long-term care.
                        </Typography>

                        <div style={{paddingBottom:0,textAlign: 'center', alignSelf: 'center',  paddingTop:20, display:'flex', flexDirection: 'column' ,marginBottom:0 }}>

                          <ul style = { { fontSize:18, color:'black', marginLeft:20 , marginTop:0, textAlign: 'center', alignSelf: 'center' ,  }}>
                            <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'left', paddingBottom:'200', marginBottom:'100', width:'400'}}>
                              That set up:
                            </Typography>
                            <li >
                              <div style = { {  marginTop:10, textAlign: 'center', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                                <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'center'  , color:'black', fontSize:18}}>
                                  Hold too much moisture
                                </Typography>
                                </div>
                              </div>
                            </li>
                            <li >
                              <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                                <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                  Limit airflow to the roots
                                </Typography>
                                </div>
                              </div>
                            </li>
                            <li >
                              <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                                <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                  Hide dense material at the center that slowly damages the plant
                                </Typography>
                                </div>
                              </div>
                            </li>

                          </ul>
                        </div>
                        <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                          You don’t see the problem — you just see your orchid decline.
                        </Typography>
                        <br/>
                        <Typography variant="h5" component="h5" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                          {MainConstants.APPLICATION_NAME}&trade; Fixes What Traditional Pots Get Wrong
                        </Typography>
                      </Grid>

                      <br/>


                      <Typography variant="h4" component="h4" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', color:'black',}}>
                        A Simple System That Works
                      </Typography>
                      <br/>
                      <Typography variant="h4" component="h4" style = { {paddingLeft:10,textAlign: 'center',color:'black', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                        Fill → Soak → Drain
                      </Typography>
                      <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                        {MainConstants.APPLICATION_NAME}&trade; turns orchid care into a simple, repeatable routine:
                      </Typography>
                      <div style={{paddingBottom:0,textAlign: 'center', alignSelf: 'center',  paddingTop:20, display:'flex', flexDirection: 'column' ,marginBottom:0 }}>
                        <ol style = { { fontSize:18, color:'black', marginLeft:20, marginTop:0  , textAlign: 'center', alignSelf: 'center' , }}>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Fill the built-in reservoir
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Soak the roots and bark (10–15 minutes)
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Drain completely—no tipping required
                              </Typography>
                              </div>
                            </div>
                          </li>

                        </ol>
                      </div>
                      <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                        That’s it. No guesswork. No mess.
                      </Typography>





                      <br/>
                      <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'10', marginBottom:'10', width:'300', fontSize:28}}>
                        Why {MainConstants.APPLICATION_NAME}&trade; Works
                      </Typography>
                      <div style={{paddingBottom:0,textAlign: 'center', alignSelf: 'center',  paddingTop:20, display:'flex', flexDirection: 'column' ,marginBottom:0 }}>

                        <ul style = { { fontSize:18, color:'black', marginLeft:20, marginTop:0 , textAlign: 'center', alignSelf: 'center',}}>
                          <li>
                            <div style = { {  marginTop:1, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Integrated soak-and-drain system (Patent Pending)
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div style = { {  marginTop:1, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Prevents overwatering and standing water
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Encourages a consistent watering routine
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Supports healthier roots through proper drainage and airflow
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Eliminates shared soaking containers (reduces disease risk)
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Keeps watering clean and contained for indoor use
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                No removing liners from decorative pots
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                No messy soaking containers
                              </Typography>
                              </div>
                            </div>
                          </li>

                        </ul>
                      </div>
                      {/*} <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'left', alignSelf: 'left', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                        That’s it. No guesswork. No mess.
                      </Typography>*/}

                      <br/>
                      <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300',  fontSize:28}}>
                        Designed for Real Life
                      </Typography>

                      <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingTop:'200', marginBottom:'100', marginTop:'150', width:'300'}}>
                        {MainConstants.APPLICATION_NAME}&trade; simplifies orchid care without disrupting your space or routine:
                      </Typography>
                      <div style={{paddingBottom:0,textAlign: 'center', alignSelf: 'center',  paddingTop:20, display:'flex', flexDirection: 'column' ,marginBottom:0 }}>

                        <ul style = { { fontSize:18, color:'black', marginLeft:20, marginTop:0 , textAlign: 'center', alignSelf: 'center', }}>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Built-in reservoir for easy soaking
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Bottom drainage valve
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Optional airflow after draining for healthier roots
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Clean, splash-free design
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Each plant has its own dedicated watering environment
                              </Typography>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>


                      <br/>
                      <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300' , fontSize:28}}>
                        Who {MainConstants.APPLICATION_NAME}&trade; Is For
                      </Typography>
                      <div style={{paddingBottom:0,textAlign: 'center', alignSelf: 'center',  paddingTop:20, display:'flex', flexDirection: 'column' ,marginBottom:0 }}>

                        <ul style = { { fontSize:18, color:'black', marginLeft:20, marginTop:0 ,alignSelf: 'center' }}>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Beginners learning how to care for orchids
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Busy plant owners who want a simple routine
                              </Typography>
                              </div>
                            </div>
                          </li>
                          <li >
                            <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                              <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Anyone frustrated with inconsistent watering
                              </Typography>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <br/>
                      <Grid container spacing={24}>
                        <Grid   item xs={2} sm={2}  >
                        </Grid>
                        <Grid   item xs={12} sm={12}   md={8} lg={8}   xl={8} >
                      <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300' , fontSize:34, color:'#BF360C',}}>
                        What’s Included
                      </Typography>
                      {/*<Typography variant="h5" component="h2" style = { {marginLeft:10,  marginTop:15, textAlign: 'left', alignSelf: 'center'  , color:'black', fontSize:18}}>
                        Each Orchima™ pot includes:
                      </Typography> */}
                      <br/>

                      <ol>


                        <div>

                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <Grid container spacing={24}>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ flex: 1 }}>

                                </div>
                              </Grid>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200 , justifySelf:'flex-end'  }}>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                    Click any picture to see a larger view.
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                        </div>

                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <Grid container spacing={24}>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                  Each {MainConstants.APPLICATION_NAME}&trade; pot purchase includes the pot, liner, and screen filter.
                                </Typography>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200, justifySelf:'flex-end'  }}>
                                  <Zoom>
                                    <Image
                                        //src="/static/images/IMG_3615.JPG"
                                        src="/static/images/Parts1.png"
                                        aspectRatio='(6/4)'
                                    />
                                  </Zoom>
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <Grid container spacing={24}>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                  For easy drainage, the pot includes a valve at the bottom.
                                </Typography>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                    Open the valve to release any excess water. Once the pot is fully drained, the valve can be left open to allow airflow to the roots.
                                  </Typography>
                                  {/*<Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:14}}>
                                Please note that the pot is shown on its side in this picture to highlight the valve. In actual use, the pot should remain
                                upright and filled with water while you open the valve with your other hand.</Typography>*/}
                                </div>
                              </Grid>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200,justifySelf:'flex-end'  }}>
                                  <Zoom>
                                    <Image
                                        //src="/static/images/IMG_3615.JPG"
                                        src="/static/images/BottomWithValve.png"
                                        aspectRatio='(3/4)'
                                    />
                                  </Zoom>
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <Grid container spacing={24}>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                  The pot features a built-in edge that provides an easy grip, making it simple to lift and carry.
                                </Typography>
                                  {/*<Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Make sure the Orchima pot is fully drained before removing it from the sink.
                              </Typography>*/}
                                </div>
                              </Grid>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200, justifySelf:'flex-end'   }}>
                                  <Zoom>
                                    <Image
                                        //src="/static/images/IMG_3615.JPG"
                                        src="/static/images/OrchimaEdge.png"
                                        aspectRatio='(3/4)'
                                    />
                                  </Zoom>
                                </div>
                              </Grid>
                            </Grid>

                          </div>

                        </li>
                      </ol>
                        </Grid>
                          <Grid   item xs={12} sm={12}   md={2} lg={2}   xl={2} >
                          </Grid>




                          {/*<Grid item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                    </Grid>*/}

                        </Grid>
                      {/*}
                      <ul style = { { fontSize:18, color:'black', marginLeft:20 }}>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Orchima™ pot
                            </Typography>
                            </div>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Inner liner
                            </Typography>
                            </div>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Screen filter
                            </Typography>
                            </div>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Built-in drainage valve
                            </Typography>
                            </div>
                          </div>
                        </li>
                      </ul>*/}
                      <br/>
                      <br/>

                      <Typography variant="h4" component="h4" style = { {paddingLeft:10,textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', color:'#BF360C',}}>
                        {MainConstants.APPLICATION_NAME}™  in Action
                      </Typography>
                      <Typography  style = { { textAlign: 'center', alignSelf: 'center'  , color:'black', fontSize:20}}>
                        View the {MainConstants.APPLICATION_NAME}™ pot in action through the videos shown below
                      </Typography>
                      <br/>
                      <ImageGallery items={images}
                                    thumbnailTitle="TumbNails Titles"
                                    description={"description"}
                                    thumbnailPosition={'bottom'}
                                    showBullets={true}
                                    showIndex={true}
                                    showPlayButton={false}
                                    showNav={false}
                                    showFullscreenButton={false}/>
                      <br/>
                      <br/>


                      <br/>

                    </Grid>
                    <Grid   item xs={1} sm={1}  >
                    </Grid>
                  </Grid>

                  <Grid container spacing={24}>
                    <Grid   item xs={2} sm={2}  >
                    </Grid>
                    <Grid   item xs={12} sm={12}   md={8} lg={8}   xl={8} >

                      {/*<Typography  style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:24}}>
                        {MainConstants.APPLICATION_NAME}&trade; Pot Feature Details
                      </Typography>*/}


                      <Typography  style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:26}}>
                        How to Use  {MainConstants.APPLICATION_NAME}&trade;
                      </Typography>

                      <Typography  style = { { textAlign: 'left', alignSelf: 'center'  , color:'black', fontSize:16, marginLeft:5}}>
                        <span style = { { textAlign: 'center', alignSelf: 'center'  , color:'black', fontWeight:'bold', fontSize:18}}> Image Notice:</span>
                        &nbsp; Images in this section are AI-generated for illustration purposes and are designed to closely represent the Orchima™ pot. The Orchima™ logo shown in these images is for
                        visual presentation only and is not currently printed on the product.
                      </Typography>
                      <Typography  style = { { textAlign: 'left', alignSelf: 'center'  , color:'black', fontSize:16,  marginLeft:5}}>
                        For actual product photos, please refer to the images at the top of this page or in the <span style = { { textAlign: 'center', alignSelf: 'center'  , color:'black', fontWeight:'bold', fontSize:18}}>Initial Setup</span> section below.
                      </Typography>

                      <br/>
                      <ol>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>
                          <Grid container spacing={24}>
                            <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                                Rinse
                              </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Place the {MainConstants.APPLICATION_NAME}&trade; pot in a sink with the drain valve open. Run water through the top to rinse and refresh the plant.
                              </Typography>
                            </Grid>
                            <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                              <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200 ,justifySelf:'flex-end'  }}>
                                <Zoom>
                                  <Image
                                      //src="/static/images/IMG_3615.JPG"
                                      src="/static/images/step1.png"
                                      aspectRatio='(4/4)'
                                  />
                                </Zoom>
                              </div>
                            </Grid>
                          </Grid>

                        </li>
                        <br/>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>
                          <Grid container spacing={24}>
                            <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                                Close the Valve
                              </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Once the water has fully drained, lift the pot and close the drain valve.
                              </Typography>
                            </Grid>
                            <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                              <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200 ,justifySelf:'flex-end'  }}>
                                <Zoom>
                                  <Image
                                      //src="/static/images/IMG_3615.JPG"
                                      src="/static/images/step2.png"
                                      aspectRatio='(4/4)'
                                  />
                                </Zoom>
                              </div>
                            </Grid>
                          </Grid>

                        </li>
                        <br/>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>
                          <Grid container spacing={24}>
                            <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                                Fill
                              </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Fill the pot to the rim with water, or a mixture of water and orchid fertilizer.
                              </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Tip: Alternate between plain water and a water–fertilizer mix with each watering cycle. The frequency of watering depends on the
                                environment in which your orchid lives and the level of moisture in that environment.
                              </Typography>
                            </Grid>
                            <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                              <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200 ,justifySelf:'flex-end'  }}>
                                <Zoom>
                                  <Image
                                      //src="/static/images/IMG_3615.JPG"
                                      src="/static/images/step3.png"
                                      aspectRatio='(4/4)'
                                  />
                                </Zoom>
                              </div>
                            </Grid>
                          </Grid>
                        </li>
                        <br/>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>
                          <Grid container spacing={24}>
                            <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                                Soak
                              </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Let the bark soak for up to 15 minutes.
                              </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Soaking time may vary depending on your environment and humidity levels.
                              </Typography>
                            </Grid>
                            <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                              <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200 ,justifySelf:'flex-end'  }}>
                                <Zoom>
                                  <Image
                                      //src="/static/images/IMG_3615.JPG"
                                      src="/static/images/step4.png"
                                      aspectRatio='(4/4)'
                                  />
                                </Zoom>
                              </div>
                            </Grid>
                          </Grid>
                        </li>
                        <br/>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>
                          <Grid container spacing={24}>
                            <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                                Drain
                              </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Open the bottom valve and allow all water to drain completely.
                              </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                This may take a few minutes.
                              </Typography>
                            </Grid>
                            <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                              <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200 ,justifySelf:'flex-end'  }}>
                                <Zoom>
                                  <Image
                                      //src="/static/images/IMG_3615.JPG"
                                      src="/static/images/step5.png"
                                      aspectRatio='(4/4)'
                                  />
                                </Zoom>
                              </div>
                            </Grid>
                          </Grid>

                        </li>
                        <br/>
                        <Typography  style = { { textAlign: 'left', alignSelf: 'center'  , color:'black', fontSize:20}}>
                          Watering frequency depends on your environment and humidity.
                        </Typography>
                        <br/>
                        <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontStyle: 'italic', fontSize:18, fontWeight:'550'}}>
                          Hint: A horizontal valve handle means the valve is closed—think “horizontal” as a halt in flow.
                        </Typography>
                        <Grid container spacing={24}>
                          <Grid   item xs={12} sm={12}   md={3} lg={3}   xl={3} >
                          <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200 ,justifySelf:'flex-end'  }}>
                            <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontStyle: 'italic', fontSize:18, fontWeight:'550'}}>
                              Valve - Open position
                            </Typography>
                            <Zoom>
                              <Image
                                  //src="/static/images/IMG_3615.JPG"
                                  src="/static/images/ValveOpen2.png"
                                  aspectRatio='(4/4)'
                              />
                            </Zoom>
                          </div>
                          </Grid>
                          <Grid   item xs={12} sm={12}   md={3} lg={3}   xl={3} >
                          <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200 ,justifySelf:'flex-end'  }}>
                            <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontStyle: 'italic', fontSize:18, fontWeight:'550'}}>
                              Valve - Close position
                            </Typography>
                            <Zoom>
                              <Image
                                  //src="/static/images/IMG_3615.JPG"
                                  src="/static/images/ValveClose.png"
                                  aspectRatio='(4/4)'
                              />
                            </Zoom>
                          </div>
                          </Grid>
                          <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >

                          </Grid>
                        </Grid>



                      </ol>




                      <br/>
                      {/*<Typography  style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:26}}>
                        {MainConstants.APPLICATION_NAME}&trade; Instructions on how to plant your orchid.
                      </Typography>*/}
                      <Typography  style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:26}}>
                        Initial Setup: Planting Your Orchid
                      </Typography>

                      <br/>

                      <div  style={{ flex: 1, marginLeft:30, }}>
                        <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                          Before You Begin
                        </Typography>
                        <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                          This system is designed for bark-based orchid mixes, such as combinations of bark, charcoal, and perlite.
                        </Typography>
                        <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                          If your orchid is already in a well-ventilated liner with proper airflow, you may not need to repot — simply place it directly into the {MainConstants.APPLICATION_NAME}&trade; pot.
                        </Typography>

                      </div>
                      <br/>
                      {/*<div  style={{ flex: 1, marginLeft:30, }}>
                        <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                          Note:
                        </Typography>
                        <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                          “Bark” refers to any suitable orchid growing medium, including bark alone or a mix such as bark, charcoal, and perlite.
                          Use what works best for your environment.
                        </Typography>

                      </div>*/}
                      <ol>

                        <div>
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <Grid container spacing={24}>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ flex: 1 }}>


                                </div>
                              </Grid>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200, justifySelf:'flex-end'  }}>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                    Click any picture to see a larger view.
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                        </div>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <Grid container spacing={24}>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ flex: 1 }}>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                                    Prepare the liner
                                  </Typography>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                    Add a few small stones to the bottom of the liner to prevent it from floating when water is added.
                                  </Typography>
                                  {/*<Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Add a few small stones to the bottom of the liner. This prevents the liner from floating once water is added to the {MainConstants.APPLICATION_NAME}&trade; Pot.
                              </Typography>*/}
                                </div>
                              </Grid>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200 ,justifySelf:'flex-end'  }}>
                                  <Zoom>
                                    <Image
                                        //src="/static/images/IMG_3615.JPG"
                                        src="/static/images/LineWithStones.png"
                                        aspectRatio='(6/4)'
                                    />
                                  </Zoom>
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <Grid container spacing={24}>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ flex: 1 }}>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                                    Add Bark
                                  </Typography>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                    Fill the lower part of liner with orchid bark.
                                  </Typography>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                    Note: “Bark” refers to any suitable orchid growing medium, including bark alone or a mixture of bark, charcoal, and perlite.
                                    Use what works best for your environment.
                                  </Typography>

                                </div>
                              </Grid>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200, justifySelf:'flex-end'   }}>
                                  <Zoom>
                                    <Image
                                        //src="/static/images/IMG_3615.JPG"
                                        src="/static/images/LinerWithBarks.png"
                                        aspectRatio='(6/4)'
                                    />
                                  </Zoom>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <Grid container spacing={24}>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ flex: 1 }}>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                                    Rinse Thoroughly
                                  </Typography>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                    Rinse the bark well to remove fine debris.
                                  </Typography>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                    Tip: Removing fine particles helps prevent clogging of the drainage valve over time.
                                  </Typography>

                                </div>
                              </Grid>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >

                                <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200, justifySelf:'flex-end'   }}>
                                  <Zoom>
                                    <Image
                                        //src="/static/images/IMG_3615.JPG"
                                        //src="/static/images/WashingDebris.png"
                                        src="/static/images/WashingDebrisWithOrchidPlant2.png"
                                        aspectRatio='(4/6)'
                                    />
                                  </Zoom>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <Grid container spacing={24}>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ flex: 1 }}>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                                    Let It Drain
                                  </Typography>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                    Leave the liner with your orchid in the sink and allow excess water to drain or dry.
                                  </Typography>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200, justifySelf:'flex-end'   }}>
                                  <Zoom>
                                    <Image
                                        //src="/static/images/IMG_3615.JPG"
                                        src="/static/images/LinerWithPlant.png"
                                        aspectRatio='(4/6)'
                                    />
                                  </Zoom>
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                        </li>

                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <Grid container spacing={24}>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ flex: 1 }}>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                                    Insert the Filter
                                  </Typography>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                    Position the round filter at the bottom of the {MainConstants.APPLICATION_NAME}&trade; pot.
                                  </Typography>

                                </div>
                              </Grid>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200 ,justifySelf:'flex-end'  }}>
                                  <Zoom>
                                    <Image
                                        //src="/static/images/IMG_3615.JPG"
                                        src="/static/images/PotAndLiner.png"
                                        aspectRatio='(3/4)'
                                    />
                                  </Zoom>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <Grid container spacing={24}>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ flex: 1 }}>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                                    Assemble
                                  </Typography>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                    Place the planted liner into the {MainConstants.APPLICATION_NAME}&trade; Pot.
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200, justifySelf:'flex-end' }}>
                                  <Zoom>
                                    <Image
                                        //src="/static/images/IMG_3615.JPG"
                                        src="/static/images/PlacingLiner.png"
                                        aspectRatio='(3/4)'
                                    />
                                  </Zoom>

                                </div>
                              </Grid>
                            </Grid>
                          </div>

                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <Grid container spacing={24}>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{ flex: 1 }}>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18, fontWeight:'bold'}}>
                                    Enjoy
                                  </Typography>
                                  <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                    Your {MainConstants.APPLICATION_NAME}&trade; pot is now ready to use.
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid   item xs={12} sm={12}   md={6} lg={6}   xl={6} >
                                <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200, justifySelf:'flex-end'  }}>
                                  <Zoom>
                                    <Image
                                        //src="/static/images/IMG_3615.JPG"
                                        src="/static/images/OrchimaPotPlant3.png"
                                        aspectRatio='(3/4)'
                                    />
                                  </Zoom>
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                        </li>
                      </ol>

                    </Grid>





                    <Grid   item xs={12} sm={12}   md={2} lg={2}   xl={2} >
                    </Grid>




                    {/*<Grid item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                    </Grid>*/}

                  </Grid>

                  <Grid container spacing={24}>
                    <Grid item xs={12} sm={12}  md={3} lg={3}   xl={3}  >
                    </Grid>
                    <Grid   item xs={12} sm={12}  md={6} lg={6}   xl={6}  >
                    </Grid>
                    <Grid item xs={12} sm={12}  md={3} lg={3}   xl={3}  >
                    </Grid>
                  </Grid>
                </div>



                <Grid container spacing={24} >
                  <Grid   item xs={1} sm={1}  >
                  </Grid>

                  <Grid   item xs={9} sm={9}    md={9} lg={9}   xl={9} >
                    <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', marginTop:'300', width:'400', fontSize:'36'}}>
                      <Typography variant="h6" component="h2" style = { { textAlign: 'left', alignSelf: 'center'  , color:'#BF360C', fontSize:26}}>
                        Our Mission
                      </Typography>
                      <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 }}>
                        {MainConstants.APPLICATION_NAME}&trade; was created to make orchid care more accessible.
                        By simplifying the watering process, {MainConstants.APPLICATION_NAME}&trade; helps beginners succeed, gain confidence, and
                        enjoy growing orchids—while making care easier for everyone. Your orchid deserves better than trial and error.
                        <span  style = { {fontSize:20,color:'#BF360C', marginLeft:5 }}>Give it the care it actually needs.</span>
                      </Typography>
                    </div>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
                <br/>
                <Grid container spacing={24} >
                  <Grid   item xs={1} sm={1}  >
                  </Grid>

                  <Grid   item xs={9} sm={9}    md={9} lg={9}   xl={9} >
                    <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', marginTop:'300', width:'400', fontSize:'36'}}>
                      <Typography variant="h6" component="h2" style = { { textAlign: 'left', alignSelf: 'center'  , color:'#BF360C', fontSize:26}}>
                        The Significance of  the word {MainConstants.APPLICATION_NAME}&trade;
                      </Typography>
                      <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 }}>
                        {MainConstants.APPLICATION_NAME}&trade; is born from the union of two words: Orchid and Anima.
                        Anima—the soul—gives the name its essence. Together, Orchima means “the soul of the orchid,” capturing the delicate beauty, spirit, and life that orchids symbolize.

                        It’s more than just a name—it reflects harmony, elegance, and the timeless connection between nature and soul. </Typography>
                    </div>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
                <br/>
                <br/>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>

                  <Grid   item xs={9} sm={9}  >

                    <div>
                      <div  style={{ marginRight:60, marginLeft:10, marginTop:10,  marginBotton:10  }}>
                        <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , fontWeight:600 ,color:'#BF360C', }}>
                          {MainConstants.APPLICATION_NAME}&trade; Maintenance: </Typography>

                        <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , }}>
                          For steps on cleaning and removing bark debris, please follow this link  <a href="/orchimacleanup"   rel="noreferrer">{MainConstants.APPLICATION_NAME}&trade; Maintenance</a>.</Typography>
                      </div>
                    </div>
                    <div>
                      <div  style={{ marginRight:60, marginLeft:10, marginTop:10,  marginBotton:10  }}>
                        <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , fontWeight:600 ,color:'#BF360C', }}>
                          How to Care for Orchids: </Typography>

                        <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , }}>
                          For more educational content about orchids, please follow this link <a href="/orchideducation"   rel="noreferrer">Orchid Education</a>.</Typography>
                      </div>
                    </div>


                    <div>
                      <div  style={{   marginLeft:10, marginTop:10,  marginBotton:10  }}>
                        <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 ,color:'#BF360C', fontWeight:600 }}>
                          Common Orchid Problems and How to Fix Them: </Typography>
                        <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 }}>
                          Orchids can be incredibly rewarding to grow, but they don’t behave like most houseplants.
                          Many growers face similar challenges.
                          To learn about common orchid health issues and how to spot them,
                          please follow this link. <a href="/orchidproblems"   rel="noreferrer">
                          Orchid Challenges</a>
                        </Typography>
                      </div>
                      <div>
                        <div  style={{ marginRight:60, marginLeft:10, marginTop:10,  marginBotton:10  }}>
                          <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , fontWeight:600 ,color:'#BF360C', }}>
                            Disclaimer: </Typography>

                          <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , }}>
                            For product disclaimer, please follow this link <a href="/disclaimer"   rel="noreferrer">Product Disclaimer</a>.</Typography>
                        </div>
                      </div>
                      <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingLeft:20, marginRight:30, }}>
                        <img height={240} width={240} src={tempImageSource2}   style = { { marginTop:0}}/>
                      </div>

                      <div>
                        <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10  }}>
                          <Typography component="h2" variant="body1"  style = { {textAlign: 'center', alignSelf: 'center', fontSize:24 , fontWeight:600 ,color:'#BF360C', }}>
                            Orchid Organizations </Typography>
                          <ol type="A">
                            <li>
                              <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , marginBottom:15, }}>
                                <a href="https://www.aos.org/"   rel="noreferrer">American Orchid Society</a></Typography>
                            </li>
                            <li>
                              <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 ,marginBottom:15, }}>
                                <a href="https://www.orchidconservationcoalition.org/"   rel="noreferrer">Orchid Conservation Coalition</a></Typography>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>


                <br/>

                {/*}
              <a href="/privacy"   rel="noreferrer" style={{paddingLeft:10, paddingBottom:20, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <Typography component="h2" variant="body1" style = { { color:'blue'}} >
                  Privacy Policy
                </Typography>
              </a>
              <a href="/orchideducation"   rel="noreferrer">
                <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                  &lArr; Orchid Education
                </Typography>
              </a>

              <a href="/orchidproblems"   rel="noreferrer">
                <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                  &lArr; Orchid Problems
                </Typography>
              </a>
              */}

              </div>

            </Grid>


          </Grid>
          <Dialog
              open={this.state.showOrderDialog}
              onClose={this.handleClickShowOrderDialogClose}
              scroll={'paper'}

              aria-labelledby="scroll-dialog-title"
              aria-describedby="scroll-dialog-description"
              maxWidth="md"
          >
            <DialogTitle id="scroll-dialog-title">Order Information</DialogTitle>
            <DialogContent id="farshids" style={{  justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >

              {/*} {(this.props.errorCMsg.status == 200) && (<div>
              The Operation was SUCCESSFUL!  Please refresh the list by pressing the refresh button -  {this.props.errorCMsg.status}  {this.props.errorCMsg.statusText}
            </div>)}
            {(this.props.errorCMsg.status != 200) && (this.props.errorCMsg.status != null) && (<div>
              The Operation FAILED, please try again! -  {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
            </div>)}*/}
              <CreditCardForm></CreditCardForm>

            </DialogContent>
            <DialogActions>
              {/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
              <Button onClick={this.handleClickShowOrderDialogClose} color="secondary" style={{backgroundColor :'white',  border: '2px solid', color:'red', borderColor:'red', borderWidth:'2px', marginRight:20 }}>Cancel</Button>
              {/*<Button onClick={this.handleClickShowOrderDialogClose} color="secondary">Close</Button>*/}
            </DialogActions>
          </Dialog>
        </div>



    );
  }
}



OrchimaMainPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticatedBool: state.login.isAuthenticatedBool,
    userProfile: state.login.userProfile,
    loginData:state.login.loginData,

    //auth:state.login.loginData,
    //CompanyDeleteResponse:state.account.deleteCompanyResp,
    //CompanySaveResponse:state.account.saveCompanyResp,
    //locationsArray:state.location.locationsArray,
    //vcArray:state.videocontroller.vcArray,
    //camerasArray:state.camera.camerasArray,
    //errorCMsg:state.account.errorCMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    //login:login,
    //handleAuthentication:handleAuthentication,
    //isAuthenticated:isAuthenticated,
    updateUserProfileAction:updateUserProfileAction,
    saveAComment:saveAComment,
    //updateAuth:updateAuth,

  }, dispatch);
};

//export default BiomassView;
//export default withStyles(styles)(AboutPlateWiz);




//export default withStyles(styles)(AppView);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OrchimaMainPage));
